// extracted by mini-css-extract-plugin
export default {"contentPadding":"ContentPadding-ContentPadding__contentPadding--Z59H3"};